module.exports = __webpack_public_path__ + "img/symbol_0.79ef1d08.png";